import { userStore } from '@/entities/user/@x/authentication';
import { DR_LOCAL_STORAGE_KEYS } from '@/shared/constants';
import { redirect } from '@tanstack/react-router';

export function termAndConditionGuardRoute({
  currentPath,
}: {
  currentPath: string;
}) {
  const isTermsAndConditionsAccepted =
    userStore.state?.isTermsAndConditionsAccepted;

  if (
    !isTermsAndConditionsAccepted &&
    currentPath !== '/terms-and-conditions'
  ) {
    localStorage.setItem(DR_LOCAL_STORAGE_KEYS.REDIRECT_URL, currentPath);

    throw redirect({
      to: '/terms-and-conditions',
    });
  }
}
